import { useEffect, useMemo, useState } from "react";
import Modal from "./Modal";
import nuethreads from "../../assets/images/nuethreads.png";
import "./PayIn.css";
import Pagination from "./Pagination";
import {
  getInvoice,
  getOrganisation,
  getUser,
  payinData,
} from "../../config/LiveApi";
import Spinner from "../Spin/Spinner";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import { getProductCombinations } from "./productGeneration";
import { useSelector } from "react-redux";
import DataTable from "../../components/common/DataTable/DataTable";
import StatusCell from "../../components/common/TableCells/StatusCell";
import DateCell from "../../components/common/TableCells/DateCell";
import CopyCell from "../../components/common/TableCells/CopyCell";

function ReportTable({
  isLoading,
  currentItems,
  totalPages,
  currentPage,
  setCurrentPage,
  setStatus,
  allData,
  setCurrentItems,
  startDate,
  endDate,
  tableData,
  isSearchActive,
}) {
  const token = useSelector((store) => store.userReducer.token);
  const [transactionModeFilter, setTransactionModeFilter] = useState("");
  const role = useSelector((store) => store.userReducer.role);
  const [modalData, setModalData] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [orgOptions, setOrgOptions] = useState([]);
  const [selectedOrgName, setSelectedOrgName] = useState("All");
  const [listofusers, setListofUser] = useState([]);
  const [selectedBusinessName, setSelectedBusinessName] = useState("All");
  const [selectedStatus, setSelectedStatus] = useState("All");
  const [loading, setLoading] = useState(false);

  const businessOptions = useMemo(() => {
    if (!Array.isArray(listofusers)) return [];

    return listofusers.map((user) => ({
      value: user.id,
      label: user?.alias || user?.id,
    }));
  }, [listofusers]);

  const orgSelectOptions = useMemo(() => {
    if (!Array.isArray(orgOptions)) return [];

    return orgOptions.map((org) => ({
      value: org.orgName,
      label: org.orgName,
    }));
  }, [orgOptions]);

  // When a search by order id is active, always show its result (even when
  // empty -> "No Data Found"). Only fall back to the full report otherwise.
  const dataToShow = isSearchActive ? tableData : currentItems;

  useEffect(() => {
    const fetchOrganisations = async () => {
      try {
        if (role === "mops" || role === "admin" || role === "subAdmin") return;
        const response = await getOrganisation(token);
        const orgData = response.data;
        setOrgOptions(orgData);
      } catch (err) {
        console.error("Error fetching organisations:", err.message);
      }
    };

    fetchOrganisations();
  }, [token, role]);

  const fetchUsers = async () => {
    try {
      if (role === "admin" || role === "mops" || role === "subAdmin") return;
      const response = await getUser(token);
      const data = response?.data;
      const adminUsers = data.filter((user) => user.role === "admin");
      // console.log("adminUsersadminUsers",adminUsers)
      setListofUser(adminUsers);
    } catch (error) {
      console.log(error.message);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, [token, role]);

  const generatePDF = async (item) => {
    const doc = new jsPDF("p", "mm", "a4");
    const pageHeight = doc.internal.pageSize.height;

    const img = new Image();
    img.src = nuethreads;

    doc.addImage(img, "PNG", 3, 3, 32, 14);

    const transactionID = item.transactionId;
    const date = new Date(item.createdAt);
    const day = date.getDate();
    const startDate = new Date(date);
    startDate.setDate(date.getDate() + 3);

    const endDate = new Date(startDate.getTime() + 24 * 60 * 60 * 1000);

    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    const formattedDate = `${day}-${month}-${year}`;
    const customerName = item.dataItem.customerName;
    const phoneNumber = item.dataItem.customerMobile;
    const email = item.dataItem.customerEmail;
    const amount = item.dataItem.amount;

    const payoutData = await getInvoice(
      token,
      transactionID,
      startDate.toISOString(),
      endDate.toISOString(),
    );

    const productInfo = getProductCombinations(amount);
    const productList = productInfo.products;
    const discount = productInfo.balance;

    if (!("count" in payoutData)) {
      alert("Payout not available for the selected payin!!!");
      return;
    }
    const invoice = payoutData.count;

    payoutData.name = payoutData.name === undefined ? "" : payoutData.name;
    payoutData.email = payoutData.email === undefined ? "" : payoutData.email;

    doc.setFontSize(18);
    doc.text("BILL INVOICE", 105, 10, null, null, "center");

    doc.setFont("helvetica", "bold");
    doc.setFillColor(210);
    doc.text("Stretavia Media Private Limited", 105, 20, null, null, "center");

    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    doc.setTextColor(0);
    doc.text(
      "House No. 101 A-01/3, Anupam Bhawan, Azadpur Underpass, New Delhi - 110033",
      105,
      25,
      null,
      null,
      "center",
    );
    doc.text("Phone: +91 9675497136", 60, 30);
    doc.text("GSTIN: 07ABOCS5608J1ZV", 110, 30);

    doc.setFontSize(12);
    doc.text("BILL TO:", 10, 60);
    doc.setFont("helvetica", "bold");
    doc.text(`${customerName} (Buyer)`, 10, 70);
    doc.setFont("helvetica", "normal");
    doc.text(`Phone: ${phoneNumber}`, 10, 75);
    doc.text(`Email: ${email}`, 10, 80);

    doc.setFontSize(11);
    doc.text(`Invoice No: NT/${day}-${month}-${year}/${invoice}`, 20, 40);
    doc.text(`Invoice Date: ${formattedDate}`, 20, 45);

    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    doc.text(`${payoutData.name} (Seller)`, 120, 70);
    doc.setFont("helvetica", "normal");
    doc.text(`Email: ${payoutData.email}`, 120, 75);

    doc.setFillColor(216, 18, 93);
    doc.rect(10, 90, 190, 8, "F");
    doc.setTextColor(255);
    doc.text("Sr. No.", 12, 95);
    doc.text("Items", 35, 95);
    doc.text("Quantity", 85, 95);
    doc.text("Price / Unit", 115, 95);
    doc.text("Amount", 175, 95);

    doc.setTextColor(0);

    let yPosition = 105;
    let totalCount = 0;
    let totalAmount = 0;

    Object.entries(productList).forEach(([itemName, product], index) => {
      const price = parseFloat(product.price);
      const quantity = parseInt(product.quantity, 10);
      const totalPrice = price * quantity;

      const maxItemNameWidth = 45;
      const splitItemName = doc.splitTextToSize(itemName, maxItemNameWidth);
      const itemNameHeight = splitItemName.length * 5;

      if (yPosition + itemNameHeight + 10 > pageHeight - 20) {
        doc.addPage();
        yPosition = 20;
        doc.setFillColor(216, 18, 93);
        doc.rect(10, 10, 190, 8, "F");
        doc.setTextColor(255);
        doc.text("Sr. No.", 12, 15);
        doc.text("Items", 35, 15);
        doc.text("Quantity", 85, 15);
        doc.text("Price / Unit", 115, 15);
        doc.text("Amount", 175, 15);
        doc.setTextColor(0);
      }

      doc.text(`${index + 1}`, 12, yPosition);

      splitItemName.forEach((line, lineIndex) => {
        doc.text(line, 35, yPosition + lineIndex * 5);
      });

      doc.text(`${quantity}`, 85, yPosition);
      doc.text(`Rs. ${price}`, 115, yPosition);
      doc.text(`Rs. ${totalPrice}`, 175, yPosition);

      totalCount += Number(quantity);
      totalAmount += Number(totalPrice);

      yPosition += itemNameHeight + 5;
    });

    if (yPosition + 30 > pageHeight - 20) {
      doc.addPage();
      yPosition = 20;
    }

    doc.setFillColor(216, 18, 93);
    doc.rect(10, yPosition, 190, 8, "F");
    doc.setTextColor(255);
    doc.text("Total", 35, yPosition + 5);
    doc.text(`${totalCount}`, 85, yPosition + 5);
    doc.text(`Rs. ${totalAmount}`, 175, yPosition + 5);

    yPosition += 15;

    doc.setTextColor(0);
    doc.text("Discount", 10, yPosition);
    doc.text(`Rs. ${discount}`, 175, yPosition);

    yPosition += 10;

    doc.text("Received Amount", 10, yPosition);
    doc.text(`Rs. ${amount}`, 175, yPosition);

    yPosition += 30;

    doc.text("Terms & Conditions:", 20, yPosition);
    doc.text(
      "1. Customer will pay the delivery charges, if applicable",
      20,
      yPosition + 5,
    );
    doc.text(
      "2. GST liability, if any, will be borne by seller only.",
      20,
      yPosition + 10,
    );
    doc.text(
      "3. All disputes are subject to Delhi Jurisdiction.",
      20,
      yPosition + 15,
    );

    yPosition += 20;

    if (yPosition + 10 > pageHeight - 20) {
      doc.addPage();
      yPosition = 20;
    }

    doc.setFontSize(8);
    doc.setFont("helvetica", "bold");
    doc.text(
      "*This is a computer generated invoice, no stamp or signature is required.",
      100,
      yPosition,
    );

    const fileName = `Invoice_NT/${day}-${month}-${year}/${invoice}.pdf`;

    doc.save(fileName);
  };

  useEffect(() => {
    const fetchTransactions = async () => {
      setLoading(true);
      try {
        const response = await payinData(
          token,
          currentPage,
          startDate,
          endDate,
          selectedOrgName === "All" ? "" : selectedOrgName,
          selectedBusinessName === "All" ? "" : selectedBusinessName,
          selectedStatus === "All" ? "" : selectedStatus,
        );
        // console.log("Response for filter:", response);

        setCurrentItems(response);
      } catch (error) {
        console.error("Error fetching transactions:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchTransactions();
  }, [
    startDate,
    endDate,
    selectedOrgName,
    selectedBusinessName,
    currentPage,
    setCurrentItems,
    token,
    selectedStatus,
  ]);

  const columns = [];
  if (
    role === "super" ||
    role === "operation" ||
    role === "trafficManager" ||
    role === "subSuper"
  ) {
    columns.push(
      {
        key: "orgName",
        header: "Org Name",
        wrapHeader: true,
        filterable: true,
        filterType: "select",
        filterOptions: [{ value: "All", label: "All" }, ...orgSelectOptions],
        filterValue: selectedOrgName,
        onFilterChange: setSelectedOrgName,
        render: (row) => row.orgName || "N/A",
      },
      {
        key: "businessName",
        header: "Business Name",
        filterable: true,
        filterType: "select",
        filterOptions: [{ value: "All", label: "All" }, ...businessOptions],
        filterValue: selectedBusinessName,
        onFilterChange: setSelectedBusinessName,
        render: (row) => row.alias || row.userId,
      },
      {
        key: "pg",
        header: "PG Name",
        render: (row) => row.pg || "",
      },
    );
  }
  columns.push(
    {
      key: "orderId",
      header: "Order Id",
      wrapCell: true,
      render: (row) => <CopyCell value={row?.dataItem?.orderId || ""} />,
    },

    {
      key: "transactionMode",
      header: "Transaction Mode",
      wrapHeader: true,
      filterable: true,
      filterType: "menu",
      filterOptions: [
        { value: "", label: "All" },
        { value: "UPI_INTENT", label: "UPI_INTENT" },
        { value: "IMPS", label: "IMPS" },
        { value: "NEFT", label: "NEFT" },
      ],
      filterValue: transactionModeFilter,
      onFilterChange: setTransactionModeFilter,
      render: (row) => row?.dataItem?.transactionMode || "",
    },

    {
      key: "amount",
      header: "Amount(₹)",
      render: (row) => row?.dataItem?.amount || 0,
    },

    {
      key: "commission",
      header: "Comm.(₹)",
      render: (row) =>
        row.responseStatus === "SUCCESS" ? row.totalComission : 0,
    },

    {
      key: "rollingReserve",
      header: "Rolling Reserve(₹)",
      wrapHeader: true,
      render: (row) =>
        row.responseStatus === "SUCCESS" ? row.rollingReserve : 0,
    },

    {
      key: "status",
      header: "Status",
      filterable: true,
      filterType: "menu",
      thProps: {
        "data-tour": "payment-status",
      },
      filterOptions: [
        { value: "All", label: "All" },
        { value: "SUCCESS", label: "Success" },
        { value: "PROCESSING", label: "Processing" },
        { value: "FAILED", label: "Failed" },
      ],
      filterValue: selectedStatus,
      onFilterChange: setSelectedStatus,
      render: (row) => <StatusCell status={row.responseStatus} />,
    },
    {
      key: "createdAt",
      header: "Transaction Date",
      wrapHeader: true,
      render: (row) => <DateCell date={row.createdAt} />,
    },

    {
      key: "updatedAt",
      header: "Updated Date",
      wrapHeader: true,
      render: (row) => <DateCell date={row.updatedAt} />,
    },

    {
      key: "action",
      header: "Action",
      thProps: {
        "data-tour": "transaction-details",
      },
      render: (row) => (
        <button
          className="view-btn"
          onClick={() => {
            setModalData(row);
            setOpenModal(true);
          }}
        >
          View
        </button>
      ),
    },
  );
  if (role === "super" || role === "operation" || role === "subSuper") {
    columns.push({
      key: "invoice",
      header: "Invoice",
      render: (row) => (
        <button className="generate-btn" onClick={() => generatePDF(row)}>
          Generate
        </button>
      ),
    });
  }

  //ANCHOR - formattedData
  const formattedData = useMemo(() => {
    return (dataToShow || [])
      .filter((item) => item.responseStatus !== "INVALID")
      .map((item) => ({
        ...item,
        dataItem: JSON.parse(item.request || "{}"),
        responseData: JSON.parse(item.resposne || "{}"),
      }))
      .filter((item) =>
        transactionModeFilter
          ? item?.dataItem?.transactionMode === transactionModeFilter
          : true,
      );
  }, [dataToShow, transactionModeFilter]);

  return (
    <>
      <div className="exp-div"></div>

      <div data-tour="transaction-records" className="table-main-report">
        {loading || isLoading ? (
          <Spinner />
        ) : (
          <DataTable
            columns={columns}
            data={formattedData}
            loading={loading}
            emptyMessage="No Data Found"
          />
        )}

        {currentItems && (
          <Pagination
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            totalPages={totalPages}
          />
        )}
      </div>

      {openModal && modalData && (
        <Modal modalData={modalData} setOpenModal={setOpenModal} />
      )}
    </>
  );
}

export default ReportTable;